import { selectIsRokuTemplatingFeatureFlagOn } from 'core/userContext';
import { InAppContentDefinition, InAppDestination } from 'modules/graphql';
import { useEditableFieldsContext } from 'modules/templateEditor/context/EditableFieldsContext';
import { useQueryParamContext } from 'modules/templateEditor/context/QueryParamContext';
import { useSaveTemplate } from 'modules/templateEditor/hooks/useSaveTemplate';
import { useState } from 'react';
import { useSelector } from 'react-redux';

export const useDestinationSelector = () => {
  const isRokuTemplatingOn = useSelector(selectIsRokuTemplatingFeatureFlagOn);
  const { campaignId } = useQueryParamContext();

  const isCampaignFlow = !!campaignId;

  const { saveTemplate } = useSaveTemplate();
  const { liveTemplate, setCurrentMediumField } = useEditableFieldsContext();
  const inAppMediumData = (liveTemplate?.mediumData || {}) as InAppContentDefinition;

  const isNewTemplate =
    isRokuTemplatingOn &&
    !inAppMediumData?.destinations &&
    !inAppMediumData?.html &&
    !inAppMediumData?.payload;

  const [isModalOpen, setIsModalOpen] = useState<boolean>(isNewTemplate);
  const [unsetError, setUnsetError] = useState<boolean>(false);

  const appAndBrowserSelected =
    inAppMediumData?.destinations?.includes(InAppDestination.Browser) &&
    inAppMediumData?.destinations?.includes(InAppDestination.Mobile);
  const rokuSelected = !!inAppMediumData?.destinations?.includes(InAppDestination.Roku);

  const setDestinations = (newDestinations: InAppDestination[]) =>
    setCurrentMediumField('destinations', newDestinations);

  const handleAppAndBrowserClick = () => {
    if (appAndBrowserSelected)
      setDestinations([
        ...inAppMediumData?.destinations.filter(
          (destination) =>
            destination !== InAppDestination.Browser && destination !== InAppDestination.Mobile,
        ),
      ]);
    else
      setDestinations(
        inAppMediumData?.destinations
          ? [...inAppMediumData.destinations, InAppDestination.Browser, InAppDestination.Mobile]
          : [InAppDestination.Browser, InAppDestination.Mobile],
      );
  };

  const handleRokuClick = () => {
    if (rokuSelected)
      setDestinations([
        ...inAppMediumData?.destinations.filter(
          (destination) => destination !== InAppDestination.Roku,
        ),
      ]);
    else
      setDestinations(
        inAppMediumData?.destinations
          ? [...inAppMediumData.destinations, InAppDestination.Roku]
          : [InAppDestination.Roku],
      );
  };

  const handleSave = () => {
    if (!appAndBrowserSelected && !rokuSelected) {
      setUnsetError(true);
    } else {
      saveTemplate();
      setIsModalOpen(false);
    }
  };

  return {
    isModalOpen: isModalOpen && !isCampaignFlow,
    appAndBrowserSelected,
    handleAppAndBrowserClick,
    rokuSelected,
    handleRokuClick,
    handleSave,
    unsetError,
  };
};
